﻿$.fn.dxCtrlWizardResa = function custom_dxCtrlWizardResa(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizardresa dx-ctrl");
        this.createInstance(new cdxCtrlWizardResa(this, option));
    }
    return this;
}

window.cdxCtrlWizardResa = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var firstLoad = true

    function mConstruit() {
        container.empty();

        if (firstLoad) {
            firstLoad = false
            //on déconnecte et recherge au bout de 10 minutes d'inacitvité
            setInterval(function () {
                var nbMinute = option.bddCtrl.paraAppli.mGetPara("hebergement_temps_seconde_avant_suppression_resa_internet")
                if (new Date() - lastDateActiviteUser > nbMinute * 60 * 1000) {
                    mConfirmPopup("<div>Votre session a été perdue</div>", function () {
                    }, "ok", null, null, function () {
                        //hiding
                        location.reload()
                    }, true, "Déconnexion")
                }
            }, 15 * 2000);
        }

        var dataResa = option.bddCtrl.getObjet("reservation").mGetNewData()
        dataResa.from_internet = true
        var dataForResa = {
            dataReservation: dataResa,
            clDataSaisie: new cDataSaisie()
        }

        var lstItem = []
        lstItem.push($("<div/>").dxCtrlWizardAnimItemType({
            bddCtrl: option.bddCtrl,
            forcePhone: option.forcePhone,
            dxItem: $("<div/>").dxCtrlWizardItem1ResaDate({
                bddCtrl: option.bddCtrl,
                dataForResa: dataForResa
            }).dxCtrlWizardItem1ResaDate("instance")
        }).dxCtrlWizardAnimItemType("instance"))
        lstItem.push($("<div/>").dxCtrlWizardAnimItemType({
            bddCtrl: option.bddCtrl,
            forcePhone: option.forcePhone,
            dxItem: $("<div/>").dxCtrlWizardItem2ResaPanier({
                bddCtrl: option.bddCtrl,
                dataForResa: dataForResa
            }).dxCtrlWizardItem2ResaPanier("instance")
        }).dxCtrlWizardAnimItemType("instance"))
        lstItem.push($("<div/>").dxCtrlWizardAnimItemType({
            bddCtrl: option.bddCtrl,
            forcePhone: option.forcePhone,
            dxItem: $("<div/>").dxCtrlWizardItem3ResaCoordonnees({
                bddCtrl: option.bddCtrl,
                dataForResa: dataForResa
            }).dxCtrlWizardItem3ResaCoordonnees("instance")
        }).dxCtrlWizardAnimItemType("instance"))
        lstItem.push($("<div/>").dxCtrlWizardAnimItemType({
            bddCtrl: option.bddCtrl,
            forcePhone: option.forcePhone,
            dxItem: $("<div/>").dxCtrlWizardItem4ResaReglement({
                bddCtrl: option.bddCtrl,
                dataForResa: dataForResa
            }).dxCtrlWizardItem4ResaReglement("instance")
        }).dxCtrlWizardAnimItemType("instance"))
        lstItem.push($("<div/>").dxCtrlWizardAnimItemType({
            bddCtrl: option.bddCtrl,
            forcePhone: option.forcePhone,
            dxItem: $("<div/>").dxCtrlWizardItem5ResaFinal({
                bddCtrl: option.bddCtrl,
                dataForResa: dataForResa
            }).dxCtrlWizardItem5ResaFinal("instance")
        }).dxCtrlWizardAnimItemType("instance"))

        container.dxCtrlWizardAnim({
            bddCtrl: option.bddCtrl,
            isInPopup: option.isInPopup,
            showClose: option.showClose,
            lstItem: lstItem,
            forcePhone: option.forcePhone,
            indexSelectedPage: option.indexSelectedPage,
            isInPage: option.isInPage,
            dataSociete:option.bddCtrl.mGetArray("societe")[0]
        })
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}